'use client'

import dynamic from 'next/dynamic'
import type {DZTypes} from "@dealerzone/libs";
const ImageGallery = dynamic(() => import('react-image-gallery'), { ssr: false })
import "react-image-gallery/styles/image-gallery.css";
import {VehicleYoutubeEmbed} from "@/components/VehicleYoutubeEmbed";

export default function VehicleImageGallery({vehicle}: {vehicle: DZTypes.Vehicle}) {

    const items = vehicle.images.map(result =>
    ({
        original: result.large,
        thumbnail: result.small
    }));

  return (
      <div className="mb-10 px-4 md:px-0">
          <div className="rounded-xl overflow-hidden">
              <ImageGallery items={items} />
          </div>

          <VehicleYoutubeEmbed vehicle={vehicle} />
      </div>
  )
}